import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { CheckoutsView } from '../features/CheckoutsView';

export const Router: React.FC = () => {
  return (
    <>
      <BrowserRouter basename="/convert">
        <Route path="/checkout-groups/methods/list" exact component={CheckoutsView} />
      </BrowserRouter>
    </>
  );
};
